//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyBasePage from "../../components/MyBasePage";
import { RadioGroup, Radio, Field } from "vant";
import { commonApi } from "@/common/index";
import { mapState } from "vuex";
export default {
  name: "Feedback",
  components: {
    MyBasePage,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
  },
  data() {
    return {
      activeIcon: require("../../../assets/image/common/active-icon.png"),
      inactiveIcon: require("../../../assets/image/common/inactive-icon.png"),
      lists: [
        {
          value: "0",
          label: "存取款问题",
        },
        {
          value: "1",
          label: "优惠问题",
        },
        {
          value: "2",
          label: "游戏问题",
        },
        {
          value: "5",
          label: "客服投诉及建议",
        },
        {
          value: "3",
          label: "其他问题",
        },
      ],
      msgType: "0",
      content: "",
      title: "",
    };
  },
  computed: {
    ...mapState({ UUID: (state) => state.UUID }),
  },
  methods: {
    haveComToast(data, istype) {
      this.$vux.toast.show({ text: data, type: istype });
    },
    handleFeedback() {
      if (this.msgType == "") {
        this.haveComToast(
          this.$t("mine.stationLetter.selectMsgType"),
          "cancel"
        );
        return;
      }

      if (this.content == "") {
        this.haveComToast(this.$t("mine.stationLetter.descPlace"), "cancel");
        return;
      }
      if (this.title == "") {
        this.haveComToast("请输入联系方式", "cancel");
        return;
      }
      let params = {
        UUID: this.UUID,
        title: this.title,
        msgType: this.msgType,
        content: this.content,
      };
      commonApi.VIP.insertMsgSite(params)
        .then((res) => {
          this.content = "";
          this.title = "";
          this.haveComToast(this.$t("mine.stationLetter.sendSuccess"), "text");
        })
        .catch((err) => {
          this.haveComToast(err, "cancel");
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Feedback/index.vue